import { getStoreId } from "$/hooks/use-store-information"
import bookableServiceSlotsOverridesQueries from "$/lib/queries/bookable-service-slots-overrides-queries"
import bookableServiceSlotsQueries from "$/lib/queries/bookable-service-slots-queries"
import cargoBikeLimitQueries from "$/lib/queries/cargo-bike-limit-queries"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/bookable-slots")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(bookableServiceSlotsQueries.all(storeId))
      queryClient.prefetchQuery(cargoBikeLimitQueries.detail(storeId))
      queryClient.prefetchQuery(
        bookableServiceSlotsOverridesQueries.all(storeId),
      )
      // Opening hours decide whether an override's day is bookable at all.
      queryClient.prefetchQuery(storeQueries.detail(storeId))
    }

    return {
      crumb: "alfred.settings.nav.bookableSlots.label",
    }
  },
})
